import { useMemo } from "react";
import { useListDataScore } from "../stores/listDataScore";
import type { UserScriptModelFix } from "../utils/types";
import type { ItemType, MenuItemType } from "antd/lib/menu/interface";

export const useScriptOptions = () => {
  const listDataStore = useListDataScore(store => store);
  const options = useMemo<ItemType<MenuItemType>[]>(() => {
    const pubList = listDataStore.getList<UserScriptModelFix>('/api/scripts?publish=true') || [];
    const priList = listDataStore.getList<UserScriptModelFix>('/api/scripts') || [];
    const privSet = new Set(priList.map(e => e.id));
    return [
      { label: '公开', key: 'pub', type: 'group', children: pubList.filter(e => !privSet.has(e.id)).map(e => ({ key: e.id, label: e.name, value: e.id, type: 'item' })) },
      { label: '私有', key: 'pri', type: 'group', children: priList.map(e => ({ key: e.id, label: e.name, value: e.id, type: 'item' })) },
    ]
  }, [listDataStore]);
  return options;
}